export const RSS_FEED_DEFAULTS = {
  imageBorderRadius: '8px',
  titleFontSize: 24,
  titleFontFamily: 'Inter',
  subtitleFontSize: 14,
  subtitleFontFamily: 'Inter',
  titleTextColor: 'inherit',
  subtitleTextColor: 'inherit',
  titleFontWeight: 700,
  subtitleFontWeight: 400,
  borderRadius: '8px',
  borderWidth: '1px',
  borderColor: 'inherit',
  borderStyle: 'none',
  background: 'transparent',
};

export const RSS_FEED_EPISODE_DEFAULTS = {
  pageWidth: '1100px',
  pageWidthMax: '100%',
  pageBackgroundColor: 'white',
  pageGap: '64px',
  imageBorderRadius: '16px',
  titleFontSize: 30,
  titleFontFamily: 'Inter',
  titleTextColor: 'inherit',
  titleFontWeight: 700,
  descriptionFontWeight: 400,
  descriptionTextColor: 'inherit',
  descriptionFontSize: 18,
  descriptionFontFamily: 'Inter',
  dateFontSize: 12,
  dateFontFamily: 'Inter',
  dateTextColor: 'inherit',
  dateFontWeight: 400,

  contentFontSize: 16,
  contentFontFamily: 'Inter',
  contentTextColor: 'inherit',
  contentFontWeight: 400,
};
